module.exports = __webpack_public_path__ + "img/e83cd04.png";